import React, { useContext } from "react";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import module from "./AddressInputs.module.css";
import { RewardSettingContext } from "../../../contexts/RewardSettingContext";


const SelectInputWay = ({ getCustomAttribute, isAvailableSelectOcrAddress }) => {
    const { handleChangeToInputAddressWay, pageStatus, user } =
        useContext(RewardSettingContext);
    const { isManualInputAddress } = pageStatus;
    const isFinishManualEKyc = () => {
        if (!user) return false;
        if (!user.attributes) return false;
        return user.attributes["custom:finish_manual_ekyc"];
    }
    if (isFinishManualEKyc()) return null;
    return (
        <div>
            <div className={module.address_text}>
                <p>
                    証明書から取得した住所
                </p>
            </div>
            {isAvailableSelectOcrAddress ? (
                <>
                    <div>
                        <p>{getCustomAttribute("ocr_address")}</p>
                    </div>
                    <FormControl sx={{ width: "100%", paddingLeft: "32px", marginBottom: "24px" }}>
                        <RadioGroup
                            aria-labelledby="select-address-input-way"
                            defaultValue="ocr"
                            name="group-select-address-input-way"
                            value={isManualInputAddress ? "manual" : "ocr"}
                            onChange={handleChangeToInputAddressWay}
                        >
                            <FormControlLabel value={"ocr"} control={<Radio />} label="読み取った住所を使用" />
                            <FormControlLabel value="manual" control={<Radio />} label="別の住所を入力" />
                        </RadioGroup>
                    </FormControl>
                </>
            ) : (
                <div>
                    <p>証明書から住所を読み取ることができませんでした</p>
                </div>
            )}
        </div>
    )
}

export default SelectInputWay